module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-1400.8383f486.svg";